export enum Role {
  Admin = 'Admin',
  Veterinarian = 'Veterinarian',
  VeterinarianUser = 'Veterinarian_User',
  Customer = 'Customer',
}
